import React, { useEffect, useState } from "react"
import { getStockRightFSData, getStockRightFSDataSSE } from "../../../modules/quote/web"
import "./index.less"
import { quote_fs_trade_info, quote_item_fs_trade_info, single_quote, quote_item_name } from "../../shared/quotedata/index"
import { store } from "./store"
import { Observer } from "mobx-react-lite"
import { quotedata } from "../../shared/quotedata"

export function ForexTimeTrade(props: { quotedata: quotedata }) {
  return (
    <Observer>
      {() => (
        <div className="content-hq">
          <SellAndBuy />
          <FSTrade quotedata={props.quotedata} />
        </div>
      )}
    </Observer>
  )
}

function SellAndBuy() {
  return (
    <Observer>
      {() => (
        <>
          <ul className="tb-sell">
            <li>
              <span>卖出(ask)</span>
              {single_quote[quote_item_name.卖1价](store.StockDetail).element}
            </li>
          </ul>
          <ul className="tb-buy">
            <li>
              <span>买入(bid)</span>
              {single_quote[quote_item_name.买1价](store.StockDetail).element}
            </li>
          </ul>
        </>
      )}
    </Observer>
  )
}

function FSTrade(props: { quotedata: quotedata }) {
  const [tradeData, setTradeData] = useState<Array<string>>([])
  const [lastItem, setLastItem] = useState<string>("")

  useEffect(() => {
    let sse = getStockRightFSDataSSE(
      props.quotedata.quotecode,
      (data: any) => {
        setLastItem(data[data.length - 1])
        setTradeData(data.slice(0, 15))
      },
      16
    )
    return () => {
      try {
        sse.close()
      } catch (error) {}
    }
  }, [])

  return (
    <Observer>
      {() => (
        <ul className="tb-fenshi">
          <li>
            <a href="#">分时成交</a>
          </li>
          <>
            {tradeData.length > 0 &&
              tradeData.map((item: any, index: number) => {
                return (
                  <li key={index}>
                    {quote_fs_trade_info[quote_item_fs_trade_info.时间](item, true).element}
                    {quote_fs_trade_info[quote_item_fs_trade_info.成交价](tradeData, lastItem, item, index, store.StockDetail, 15).element}&nbsp;
                  </li>
                )
              })}
          </>
        </ul>
      )}
    </Observer>
  )
}
